/* Tradução PT-PT do widget Judge.me.
   Substitui strings em inglês por português usando MutationObserver
   para apanhar conteúdo injetado dinamicamente pelo Judge.me. */
(function () {
  // Mapeamento de strings EN -> PT. Ordem importa: strings mais específicas primeiro.
  var REPLACEMENTS = [
    ['Be the first to write a review', 'Sê o primeiro a escrever uma avaliação'],
    ['Customer Reviews', 'Avaliações de clientes'],
    ['Write a review', 'Escrever avaliação'],
    ['See all reviews', 'Ver todas as avaliações'],
    ['Based on', 'Com base em'],
    ['Most Recent', 'Mais recentes'],
    ['Highest Rating', 'Melhor classificação'],
    ['Lowest Rating', 'Pior classificação'],
    ['Only Pictures', 'Só com fotos'],
    ['Pictures First', 'Fotos primeiro'],
    ['Videos First', 'Vídeos primeiro'],
    ['Most Helpful', 'Mais úteis'],
    ['Sort by', 'Ordenar por'],
    ['Show only', 'Mostrar apenas'],
    ['Clear filter', 'Limpar filtro'],
    ['Filter Reviews', 'Filtrar avaliações'],
    ['Photos', 'Fotos'],
    ['Videos', 'Vídeos'],
    ['Verified Reviews', 'Avaliações verificadas'],
    ['Verified Buyer', 'Comprador verificado'],
    ['Submit Review', 'Enviar avaliação'],
    ['Cancel', 'Cancelar'],
    ['Submit', 'Enviar'],
    ['Your Name', 'O teu nome'],
    ['Your Email', 'O teu email'],
    ['Review Title', 'Título'],
    ['Rating', 'Classificação'],
    ['Your Review', 'A tua avaliação'],
    ['Upload Photos', 'Carregar fotos'],
    ['Upload Video', 'Carregar vídeo'],
    ['Thank you', 'Obrigado'],
    ['Showing', 'A mostrar'],
    ['out of', 'de'],
    ['ago', 'atrás'],
    ['days', 'dias'],
    ['day', 'dia'],
    ['hours', 'horas'],
    ['hour', 'hora'],
    ['months', 'meses'],
    ['month', 'mês'],
    ['years', 'anos'],
    ['year', 'ano'],
    ['reviews', 'avaliações'],
    ['review', 'avaliação'],
    ['Read more', 'Ler mais'],
    ['Read less', 'Ler menos'],
    ['Reply', 'Responder'],
    ['Was this helpful?', 'Isto foi útil?'],
    ['Yes', 'Sim'],
    ['No', 'Não']
  ];

  function translateNode(node) {
    if (node.nodeType === 3) {
      // Text node
      var t = node.nodeValue;
      if (!t || !t.trim()) return;
      var changed = t;
      for (var i = 0; i < REPLACEMENTS.length; i++) {
        var pair = REPLACEMENTS[i];
        if (changed.indexOf(pair[0]) !== -1) {
          // Substituir todas as ocorrencias (escape regex special chars)
          var pattern = pair[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          changed = changed.replace(new RegExp(pattern, 'g'), pair[1]);
        }
      }
      if (changed !== t) node.nodeValue = changed;
    } else if (node.nodeType === 1 && node.childNodes && node.childNodes.length > 0) {
      // Skip script/style elements
      var tag = node.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return;
      // Recursar em filhos
      for (var j = 0; j < node.childNodes.length; j++) {
        translateNode(node.childNodes[j]);
      }
      // Atributos com texto visivel (placeholder, aria-label, title)
      ['placeholder', 'aria-label', 'title'].forEach(function (attr) {
        if (node.hasAttribute && node.hasAttribute(attr)) {
          var v = node.getAttribute(attr);
          var nv = v;
          for (var k = 0; k < REPLACEMENTS.length; k++) {
            var p = REPLACEMENTS[k];
            if (nv.indexOf(p[0]) !== -1) {
              var pat = p[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
              nv = nv.replace(new RegExp(pat, 'g'), p[1]);
            }
          }
          if (nv !== v) node.setAttribute(attr, nv);
        }
      });
    }
  }

  function translateJdgm() {
    document.querySelectorAll('[class*="jdgm"], .kyoslim-reviews-section').forEach(translateNode);
  }

  function init() {
    translateJdgm();

    // Observar mudancas (Judge.me injeta conteudo async)
    var target = document.body;
    if (!target) return;
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (n.matches && (n.matches('[class*="jdgm"]') || n.querySelector('[class*="jdgm"]')))) {
            found = true;
          }
          if (n.nodeType === 3) found = true;
        });
        if (m.type === 'characterData') found = true;
      });
      if (found) {
        // Debounce ligeiro para apanhar todo o batch
        clearTimeout(window.__jdgmPtTimer);
        window.__jdgmPtTimer = setTimeout(translateJdgm, 50);
      }
    });
    observer.observe(target, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
